import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import { storage } from './utils/storage';

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const loadUser = async () => {
      const savedUser = await storage.getCurrentUser();
      if (savedUser) {
        setCurrentUser(savedUser);
      }
    };
    loadUser();
  }, []);

  return (
    <div className="App">
      {currentUser ? (
        <Dashboard currentUser={currentUser} setCurrentUser={setCurrentUser} />
      ) : (
        <Login setCurrentUser={setCurrentUser} />
      )}
    </div>
  );
}

export default App;
